import React from "react";
import Styles from './styles.module.scss';
import { useTranslation } from "react-i18next";

import icon1 from '../../theme/assets/svg/lp_afi_s2_icon1.svg';
import icon2 from '../../theme/assets/svg/lp_afi_s2_icon2.svg';
import icon3 from '../../theme/assets/svg/lp_afi_s2_icon3.svg';

const AfiS2 = () => {
    const { t } = useTranslation();

    return (
        <section className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.contentWrapTitle}`}>{t('Почему стоит запускаться')} <span>{t('с нами')}</span></div>
                <div className={`${Styles.contentWrapNote}`}><span>{t('Запуск токена — это не только про привлечение средств.')}</span> {t('Это про выход на рынок с правильной структурой, согласованными стимулами и сообществом, которое понимает ценность долгосрочного роста.')}</div>
                <div className={`${Styles.contentBox}`}>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemImgWrap}`}>
                            <img src={icon1} alt={t('Запуск с чёткой структурой')}/>
                        </div>
                        <div className={`${Styles.contentBoxItemTitle}`}>{t('Запуск с чёткой структурой')}</div>
                        <div className={`${Styles.contentBoxItemNote}`}>{t('Выйдите на рынок с понятной моделью запуска, прозрачными правилами и согласованными стимулами — без хаотичного сбора средств.')}</div>
                    </div>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemImgWrap}`}>
                            <img src={icon2} alt={t('Создание долгосрочного сообщества')}/>
                        </div>
                        <div className={`${Styles.contentBoxItemTitle}`}>{t('Создание долгосрочного сообщества')}</div>
                        <div className={`${Styles.contentBoxItemNote}`}>{t('Взаимодействуйте с аудиторией, которая ценит устойчивость, справедливость и реальную реализацию, а не краткосрочный хайп.')}</div>
                    </div>
                    <div className={`${Styles.contentBoxItem}`}>
                        <div className={`${Styles.contentBoxItemImgWrap}`}>
                            <img src={icon3} alt={t('Снижение рисков запуска')}/>
                        </div>
                        <div className={`${Styles.contentBoxItemTitle}`}>{t('Снижение рисков запуска')}</div>
                        <div className={`${Styles.contentBoxItemNote}`}>{t('Избегайте типичных ошибок запуска благодаря структурированным процессам, реалистичным ожиданиям и фокусу на развитии после запуска.')}</div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AfiS2;




